import script from "./loadMoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./loadMoreButton.vue?vue&type=script&setup=true&lang=js"

import "./loadMoreButton.vue?vue&type=style&index=0&id=79103d60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79103d60"]])

export default __exports__